import {store} from '../store.index';
import { observable, action } from 'mobx';

class share {
  @observable shareDisabled = true;
  @observable isShare = false; // 用于标识当前文档是否已经分享
  @observable shareDocId = ""; // 要分享的文件，已上传的docId
  // @observable cloudFileDocId = ""; // 当直接打开云文档文件时
  @observable shareDocsInfo = {}; // 保存分享的信息，用于后期修改或展示

  @action setShareDisabled(val) {
    this.shareDisabled = val
  }
  @action setIsShare(val) {
    this.isShare = val
  }
  @action setShareDocId(val) {
    this.shareDocId = val
  }
  // @action setCloudFileDocId(val) {
  //   this.cloudFileDocId = val
  // }
  @action setShareDocsInfo(val, save) { // val为更新的数据，save为是否上传接口
    this.shareDocsInfo = {...this.shareDocsInfo, ...val}
    if(!this.shareDocsInfo.shareId && this.shareDocsInfo.id) {
      this.shareDocsInfo.shareId = this.shareDocsInfo.id
    }
    if (save) { // 调用修改
      let params = {
        shareId: this.shareDocsInfo.shareId,
        activeDays: this.shareDocsInfo.activeDays,
        isEncrypted: this.shareDocsInfo.isEncrypted,
        drawCode: this.shareDocsInfo.drawCode
      }

      return new Promise((resolve, reject) => {
        store.docsStore.updateShare(params).then(res => {
          if(res.code === 0) {
            if (res.data.drawCode) {
              res.data.isEncrypted = true;
            } else {
              res.data.isEncrypted = false;
            }
            if(this.shareDocsInfo.codeImgUrl) {
              res.data.codeImgUrl = this.shareDocsInfo.codeImgUrl
            }
            res.data.shareId = res.data.id
            this.shareDocsInfo = res.data
            resolve(res)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
      
    }
  }
  @action base64ToBlob(code) {
    var parts = code.split(';base64,');
    var contentType = parts[0].split(':')[1];
    var raw = window.atob(parts[1]);
    var rawLength = raw.length;

    var uInt8Array = new Uint8Array(rawLength);

    for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
  }
  // 用于更换文件后, 分享功能的重启
  @action resetShare() {
    this.setIsShare(false)
    this.setShareDocId("")
    this.shareDocsInfo = {}
  }
  
}

export default share